import React, { Component } from 'react'
import HomeItem from '../components/HomeItem'
import { withRouter } from "react-router-dom";
import './Home.css'

class Home extends Component {
  
    state = {
        sections: [
          {
            title: 'hats',
            imageUrl: 'https://i.ibb.co/cvpntL1/hats.png',
            id: 1
          },
          {
            title: 'jackets',
            imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
            id: 2
          },
          {
            title: 'sneakers',
            imageUrl: 'https://i.ibb.co/0jqHpnp/sneakers.png',
            id: 3
          },
          {
            title: 'womens',
            imageUrl: 'https://i.ibb.co/GCCdy8t/womens.png',
            size: 'large',
            id: 4
          },
          {
            title: 'mens',
            imageUrl: 'https://i.ibb.co/R70vBrQ/men.png',
            size: 'large',
            id: 5
          }
        ]};
       

        render () {
          console.log(this.props)
        return (
            <div className='grid'>
                {this.state.sections.map(section=>{
                     return(
                <HomeItem type={section.title} id={section.id} imageUrl={section.imageUrl} key={section.id} />

            )})}
            </div>
        )
    }
}

export default withRouter(Home)